document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.bp-faq-item').forEach(function (item) {
    var summary = item.querySelector('.bp-faq-item__summary');
    var wrap = item.querySelector('.bp-faq-item__body-wrap');
    if (!summary || !wrap) return;

    if (item.open) {
      wrap.style.maxHeight = wrap.scrollHeight + 'px';
    }

    summary.addEventListener('click', function (event) {
      event.preventDefault();

      if (item.open) {
        wrap.style.maxHeight = wrap.scrollHeight + 'px';
        requestAnimationFrame(function () {
          wrap.style.maxHeight = '0px';
        });
        wrap.addEventListener(
          'transitionend',
          function handler() {
            item.open = false;
            wrap.removeEventListener('transitionend', handler);
          },
          { once: true }
        );
      } else {
        item.open = true;
        wrap.style.maxHeight = wrap.scrollHeight + 'px';
        wrap.addEventListener(
          'transitionend',
          function handler() {
            wrap.style.maxHeight = 'none';
            wrap.removeEventListener('transitionend', handler);
          },
          { once: true }
        );
      }
    });
  });
});
